import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
// import background from "../assets/background.png";
// import bvtq_img from "../assets/bvtq-img.jpg";
// import stamp from "../assets/Logo_BVTQ_1200.png";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#757373",
  border: "2px solid #000",
  boxShadow: 24,
  height: "90%",
  width: "750px",
  overflow: "auto",
};

const ShowTemplate = ({ current, templateData }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [typeTemplate, setTypeTemplate] = useState("");
  const [titleLevel, setTitleLevel] = useState("");
  const [subTitleLevel, setSubTitleLevel] = useState("");
  const [stampLevel, setStampLevel] = useState("");
  const [dataLevel, setDataLevel] = useState([]);
  const [levelDescription, setLevelDescription] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [alternativeText, setAlternativeText] = useState("");
  const [textColor, setTextColor] = useState("");
  const [color_description, setColorDescription] = useState("");
  const [color_alt_text, setColorAltText] = useState("");
  const [color_lvl_name, setColorLvlName] = useState("");
  const [color_lvl_subtitle, setColorLvlSubtitle] = useState("");
  const [color_alt_lvl_description, setColorLvlDescription] = useState("");
  const [backgroundImage, setBackgroundImage] = useState("");
  const [backgroundColor, setBackgroundColor] = useState("");
  const [headerImage, setHeaderImage] = useState("");
  const [createdDate, setCreatedDate] = useState("");

  const transformDate = (date) => {
    const formatDate = new Date(date).toLocaleString([], {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZone: "UTC",
    });
    const convert = formatDate.split("/").reverse();
    return convert.join("-");
  };

  const getTemplateData = async () => {
    try {
      setLoading(true);
      var requestOptions = {
        headers: { "api-key": process.env.REACT_APP_API_KEY },
      };
      const res = await fetch(
        process.env.REACT_APP_API_URL + "/builders/show/" + current,
        requestOptions
      );
      if (res.ok) {
        const json = await res.json();
        console.log("template data", json);

        setTypeTemplate(json.content);
        setTitle(json.subtitle);
        setDescription(json.image);
        setAlternativeText(json.content_two);
        setSubTitleLevel(json.content_four);
        setLevelDescription(json.content_three);
        setTextColor(json.text_color);
        setColorDescription(json.color_description);
        setColorAltText(json.color_alt_text);
        setColorLvlName(json.color_lvl_name);
        setColorLvlSubtitle(json.color_lvl_subtitle);
        setColorLvlDescription(json.color_alt_lvl_description);
        setBackgroundColor(json.color.toString());
        setCreatedDate(transformDate(json.created_at));
        getLevelData(json.level_id);
        getLevelStamp(json.level_id);
      } else {
        console.log("response was not ok");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getLevelData = async (level_id) => {
    if (!level_id) {
      return;
    }
    try {
      setLoading(true);
      var requestOptions = {
        headers: { "api-key": process.env.REACT_APP_API_KEY },
      };
      const res = await fetch(
        process.env.REACT_APP_API_URL + "/levels/show/" + level_id,
        requestOptions
      );
      if (res.ok) {
        const json = await res.json();
        let subCategoriesArray = JSON.parse(json.subcategories);
        setTitleLevel(json.title);
        setDataLevel(subCategoriesArray);
      } else {
        console.log("response was not ok");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getLevelStamp = async (level_id) => {
    try {
      setLoading(true);
      var requestOptions = {
        headers: { "api-key": process.env.REACT_APP_API_KEY },
      };
      const res = await fetch(
        process.env.REACT_APP_API_URL + "/levels/get_attachments/" + level_id,
        requestOptions
      );
      if (res.ok) {
        const json = await res.json();
        let url = json.url.replace(
          json.url.split("rails")[0],
          process.env.REACT_APP_DOWNLOAD_URL
        );
        setStampLevel(url);
      } else {
        console.log("response was not ok");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getHeaderImage = async () => {
    try {
      setLoading(true);
      var requestOptions = {
        headers: { "api-key": process.env.REACT_APP_API_KEY },
      };
      const res = await fetch(
        process.env.REACT_APP_API_URL + "/builders/get_header_image/" + current,
        requestOptions
      );
      if (res.ok) {
        const json = await res.json();
        let url = json.url.replace(
          json.url.split("rails")[0],
          process.env.REACT_APP_DOWNLOAD_URL
        );
        setHeaderImage(url);
      } else {
        console.log("response was not ok");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getAttachments = async () => {
    try {
      setLoading(true);
      var requestOptions = {
        headers: { "api-key": process.env.REACT_APP_API_KEY },
      };
      const res = await fetch(
        process.env.REACT_APP_API_URL + "/builders/get_attachments/" + current,
        requestOptions
      );
      if (res.ok) {
        const json = await res.json();
        let url = json.url.replace(
          json.url.split("rails")[0],
          process.env.REACT_APP_DOWNLOAD_URL
        );
        setBackgroundImage(url);
        console.log("url", url);
      } else {
        console.log("response was not ok");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (templateData) {
      if (templateData.dataLevel.id) {
        getLevelData(templateData.dataLevel.id);
        getLevelStamp(templateData.dataLevel.id);
      } else {
        getLevelData(templateData.dataLevel);
        getLevelStamp(templateData.dataLevel);
      }
      setTypeTemplate(templateData.typeTemplate);
      setTitle(templateData.title);
      setDescription(templateData.description);
      setHeaderImage(templateData.headerImage);
      setAlternativeText(templateData.alternativeText);
      setSubTitleLevel(templateData.levelSubtitle);
      setLevelDescription(templateData.levelDescription);
      setTextColor(templateData.textColor);
      setColorDescription(templateData.color_description);
      setColorAltText(templateData.color_alt_text);
      setColorLvlName(templateData.color_lvl_name);
      setColorLvlSubtitle(templateData.color_lvl_subtitle);
      setColorLvlDescription(templateData.color_alt_lvl_description);
      setBackgroundImage(templateData.backgroundImage);
      setBackgroundColor(templateData.backgroundColor);
      setCreatedDate(transformDate(templateData.createdDate));
    } else {
      getTemplateData();
      getHeaderImage();
      getAttachments();
    }
  }, []);

  return (
    <Box sx={style}>
      {loading || !dataLevel ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100%",
            backgroundColor: "background.paper",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: "1200px",
              p: "16px 58px 96px 58px",
              backgroundImage: backgroundImage
                ? `url("${backgroundImage}")`
                : `-webkit-linear-gradient(top, ${backgroundColor} 0%, rgb(255, 255, 255) 100%)`,
              backgroundPosition: backgroundImage && "center",
              backgroundSize: backgroundImage && "cover",
              backgroundRepeat: backgroundImage && "no-repeat",
              backgroundColor: backgroundColor || "background.paper",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "80px",
                  fontFamily: "var(--main-font-family)",
                  color: textColor && textColor,
                }}
              >
                {title}
              </Typography>
              <Typography
                variant="h6"
                align="center"
                sx={{
                  fontWeight: "600",
                  color: color_description && color_description,
                }}
              >
                {description}
              </Typography>
              {typeTemplate !== "option 1" && (
                <img src={headerImage} alt="img" style={{ width: "650px" }} />
              )}
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "600",
                  mt: "36px",
                  mb: "16px",
                  fontFamily: "var(--main-font-family)",
                }}
              >
                Name
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  mt: "16px",
                  mb: "64px",
                  color: color_alt_text && color_alt_text,
                }}
              >
                {alternativeText}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "600",
                  mt: "16px",
                  color: color_lvl_name && color_lvl_name,
                }}
              >
                {titleLevel}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "600",
                  mt: "16px",
                  mb: "64px",
                  color: color_lvl_subtitle && color_lvl_subtitle,
                }}
              >
                {subTitleLevel}
              </Typography>
              <img src={stampLevel} alt="stamp" style={{ width: "78px" }} />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Typography sx={{ fontWeight: "600", mr: "6px" }}>
                  {t("ShowTemplate.0")}:
                </Typography>
                <Typography>{createdDate}</Typography>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Typography sx={{ fontWeight: "600", mr: "6px" }}>
                  {t("ShowTemplate.1")}:
                </Typography>
                <Typography>Signature</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: "1200px",
              marginTop: "20px",
              p: "96px 58px 96px 58px",
              backgroundImage: backgroundImage
                ? `url("${backgroundImage}")`
                : `-webkit-linear-gradient(top, ${backgroundColor} 0%, rgb(255, 255, 255) 100%)`,
              backgroundPosition: backgroundImage && "center",
              backgroundSize: backgroundImage && "cover",
              backgroundRepeat: backgroundImage && "no-repeat",
              backgroundColor: backgroundColor || "background.paper",
            }}
          >
            <Box>
              <Typography
                variant="h6"
                sx={{
                  mb: "28px",
                  color: color_alt_lvl_description && color_alt_lvl_description,
                }}
              >
                {levelDescription}
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: "600", mb: "28px" }}>
                {t("ShowTemplate.2")}:
              </Typography>
              <Box sx={{ ml: "28px" }}>
                <ul>
                  {dataLevel
                    .filter(({ points }) => points > 0)
                    .map(({ name, points }, i) => (
                      <li key={i}>
                        <Typography>
                          {`${name}: ${points} credit points`}
                        </Typography>
                      </li>
                    ))}
                </ul>
              </Box>
              <Typography className="mt-2">
                Die Ausbildung wurde am <strong>{createdDate}</strong>{" "}
                abgeschlossen.
              </Typography>
              <Typography className="mt-1">
                Es besteht Fortbildungspflicht
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography>
                BVTQ e.V., Winkeler Straße 52 a · 65366 Geisenheim · 06722
                4025717
              </Typography>
              <Typography>
                info@taijiquan-qigong.de www.taijiquan-qigong.de
              </Typography>
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default ShowTemplate;
